import { createI18n } from "vue-i18n";
import localZhCn from "./lang/zh-cn";
import localEn from "./lang/en";

// i18n初始化配置
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式，则需要将其设置为 false
  locale: localStorage.getItem("locale"),
  fallbackLocale: "zh-cn",// 当找不到对应语言环境的翻译时语言包
  messages: {
    "zh-cn": localZhCn,
    "en": localEn,
  },
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  globalInjection: true
});

export default i18n;
